import utils from '../utils'

export const sensorType = (state, getters) => {
  if (state.nodeType != 'channel_collection' || state.node.data.device == null) {
    return null
  }
  let devType = state.node.data.device.sensor != null ? 'sensor' : 'digital_sensor'
  let devDesc = state.node.data.device[devType]
  let devObj = state.deviceInventory[devType].children
    .find(x => x.value == devDesc[0]).children
    .find(x => x.value == devDesc[1]).data
  return devType == 'sensor' ? devObj.type : devObj.sensor_type
}

export const allChannel = (state, getters) => {
  let result = []
  for (let sta of state.data.station) {
    for (let cha of sta.channel_collection) {
      result.push(cha.data)
    }
  }
  return result
}

export const usedNetworks = (state, getters) => {
  return getters.allChannel.map(x => x.network)
}

export const usedLocations = (state, getters) => {
  return getters.allChannel.map(x => x.location)
}

export const nodeContainer = (state, getters) => {
  return (
    state.nodeType == 'network' ? state.data.network :
    state.nodeType == 'station' ? state.data.station :
    state.nodeType == 'location' ? state.stationNode.location :
    state.nodeType == 'channel_collection' ? state.stationNode.channel_collection :
    null
  )
}

export const isNetworkUsed = (state, getters) => netId => {
  return getters.usedNetworks.filter(x => x == netId).length > 0
}

export const isLocationUsed = (state, getters) => locId => {
  return getters.usedLocations.filter(x => x == locId).length > 0
}

export const canDeleteNode = (state, getters) => nodeId => {
  if (state.nodeType == 'network') {
    return !getters.isNetworkUsed(nodeId)
  } else if (state.nodeType == 'location') {
    return !getters.isLocationUsed(nodeId)
  }
  return true
}
